(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soulstone-merch-carousel"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(!root||root.dataset.ssReady==='true')return;root.dataset.ssReady='true';var track=root.querySelector('[data-ss-track]'),slides=[].slice.call(root.querySelectorAll('[data-ss-slide]')),dots=[].slice.call(root.querySelectorAll('[data-ss-dot]')),prev=root.querySelector('[data-ss-prev]'),next=root.querySelector('[data-ss-next]'),index=0,timer=null,startX=0,delta=0;if(!track||!slides.length)return;function go(i){index=(i+slides.length)%slides.length;track.style.transform='translate3d(-'+(index*100)+'%,0,0)';dots.forEach(function(d,j){d.classList.toggle('is-active',j===index)})}function stop(){if(timer){clearInterval(timer);timer=null}}function start(){stop();timer=setInterval(function(){go(index+1)},5500)}if(prev)prev.onclick=function(){go(index-1);start()};if(next)next.onclick=function(){go(index+1);start()};dots.forEach(function(d){d.onclick=function(){go(Number(d.dataset.ssDot));start()}});root.addEventListener('touchstart',function(e){startX=e.touches[0].clientX;delta=0;stop()},{passive:true});root.addEventListener('touchmove',function(e){delta=e.touches[0].clientX-startX},{passive:true});root.addEventListener('touchend',function(){if(Math.abs(delta)>45)go(index+(delta<0?1:-1));start()},{passive:true});go(0);start()}function all(){document.querySelectorAll('[data-ss-merch-carousel]').forEach(init)}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all,{once:true});else all();document.addEventListener('shopify:section:load',function(e){init(e.target.querySelector('[data-ss-merch-carousel]'))})})();

  } catch(e) { console.error(e); }
})();
})();
